import common from './common';
import fieldValidation from './fieldValidation';
import invoiceManagement from './invoiceManagement';

const vi = { common, invoiceManagement, fieldValidation };
export default vi;
